module.exports = __webpack_public_path__ + "img/house-persons.22007e53.svg";